var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CampaignOverview',{attrs:{"id":_vm.$route.params.id}})}
var staticRenderFns = []

export { render, staticRenderFns }